import { EntityWithId } from 'src/types'

export const ClienteTipoLCTCFields = {
    Descripcion: 'vchDescClienteTipo',
    Activo: 'bitActivo'
} as const

export type ClienteTipoLCTCDTO = EntityWithId & {
    [ClienteTipoLCTCFields.Descripcion]: string
    [ClienteTipoLCTCFields.Activo]: boolean
}

export const ClienteSubTipoLCTCFields = {
    Descripcion: 'vchDescClienteSubTipo',
    Activo: 'bitActivo'
} as const

export type ClienteSubTipoLCTCDTO = EntityWithId & {
    [ClienteSubTipoLCTCFields.Descripcion]: string
    [ClienteSubTipoLCTCFields.Activo]: boolean
}

export const RelacionLCTCFields = {
    Id: 'id',
    CodSectorComercial: 'sinCodOperacionLCTCSectorComercial',
    NombreSectorComercial: 'vchNombreSectorComercial',
    CodClienteTipo: 'sinCodOperacionLCTCClienteTipo',
    DescripcionClienteTipo: 'vchDescClienteTipo',
    CodClienteSubTipo: 'sinCodOperacionLCTCClienteSubTipo',
    DescripcionClienteSubTipo: 'vchDescClienteSubTipo',
    Activo: 'bitActivo'
} as const

export type RelacionLCTCViewDTO = {
    [RelacionLCTCFields.Id]: number
    [RelacionLCTCFields.CodSectorComercial]: number
    [RelacionLCTCFields.NombreSectorComercial]: string
    [RelacionLCTCFields.CodClienteTipo]: number
    [RelacionLCTCFields.DescripcionClienteTipo]: string
    [RelacionLCTCFields.CodClienteSubTipo]: number
    [RelacionLCTCFields.DescripcionClienteSubTipo]: string
    [RelacionLCTCFields.Activo]: boolean
}

export type RelacionLCTCItemDTO = {
    codClienteTipo: number
    codClienteSubTipo: number
}
